import ReservedResourcesBulkEditForm from './reserved-resources-bulk-edit-form'
import { ReservedResourceF } from '../../../types/reservation-detail.types'

type ReservedResourcesBulkEditDialogProps = {
  propertyId: string
  open: boolean
  onClose: () => void
  onSuccess?: () => Promise<void>
  reservedResources: ReservedResourceF[]
}

export default function ReservedResourcesBulkEditDialog({ propertyId, open, onClose, onSuccess, reservedResources }: ReservedResourcesBulkEditDialogProps) {
  return (
    <ReservedResourcesBulkEditForm
      appearance={{
        type: 'DIALOG',
        open: open,
        onClose: onClose,
        onBackdropClick(event) {
          event?.stopPropagation()
        },
        noContentTopPadding: true,
        maxWidth: '350px',
      }}
      reservedResources={reservedResources}
      onBack={onClose}
      onSuccess={onSuccess}
      propertyId={propertyId}
    />
  )
}
